import * as v from 'valibot';

export const IttCartItemSchema = v.object({
    name: v.string(),
    articleNumber: v.string(),
    price: v.object({
        value: v.pipe(v.number(), v.finite()),
        currency: v.string(),
    }),
});

export type IttCartItem = v.InferOutput<typeof IttCartItemSchema>;

export function isCartItem(value: unknown): value is IttCartItem {
    return v.is(IttCartItemSchema, value);
}
